import axios, { AxiosError, AxiosInstance, AxiosRequestConfig } from "axios";
import { UserContextState } from "store/reducers/user-context.reducer";
import { Config } from "config";
import { dispatchLogout } from "store/actions/user-context.actions";
import { Store } from "redux";
import {
  dispatchError,
  dispatchOffline
} from "store/actions/notification.actions";
import { NotificationTypeEnum } from "common/enums/NotificationTypeEnum";
import { SessionState } from "store/reducers/session.reducer";
import moment from "moment";
import { createHelenaSession } from "store/actions/helena.actions";
import { ThunkDispatch } from "redux-thunk";
import { GlobalState } from "store/configure-store";
import { HelenaAction } from "store/types/helena.types";
import { selectSessionKey } from "store/reducers/helena.reducer";

export let api: AxiosInstance;
export let apiClientAuthenticated: AxiosInstance;
export let apiClientUnauthenticated: AxiosInstance;
export let apiCorilusPassport: AxiosInstance;

export const setupHttp = (store: Store, config: Config) => {
  const dispatch = store.dispatch as ThunkDispatch<
    GlobalState,
    void,
    HelenaAction
  >;

  api = axios.create({
    baseURL: config.backendUrl
  });
  api.interceptors.request.use((config: AxiosRequestConfig) => {
    const userContext: UserContextState = store.getState().userContext;
    const sessionContext: SessionState = store.getState().sessionContext;
    if (userContext) {
      config.headers.common["practice"] = userContext.practice;
      config.headers.common[
        "Authorization"
      ] = `Bearer ${sessionContext.accessToken}`;
    }
    return config;
  });
  api.interceptors.response.use(
    response => response,
    error => {
      if (typeof error.response === "undefined") {
        dispatchOffline()(dispatch);
        error.response = {
          data: NotificationTypeEnum.ERROR
        };
      } else {
        const { status } = error.response;
        switch (status) {
          case 401:
            dispatchLogout()(dispatch);
            break;
          case 404:
          case 502:
          case 503:
            dispatchOffline()(dispatch);
            break;
          default:
            dispatchError(
              getMessageFromError(error),
              getCorrelationIdFromError(error)
            )(dispatch);
        }
      }
      return Promise.reject(error);
    }
  );

  /**
   * Interceptor for Helena calls (expect /session call), refreshes session if needed.
   */
  api.interceptors.request.use(
    async config => {
      const state = store.getState() as GlobalState;
      const regex = /\/secured\/rs\/caregivers\/([\d]*)\/helena\/(?!.*\bsession\b)/;
      let m;

      if (
        config.url != null &&
        (m = regex.exec(config.url)) !== null &&
        config.data &&
        config.data["sessionKey"]
      ) {
        const userId = m[1];
        const sessionKey = selectSessionKey(state.helena);
        if (
          sessionKey &&
          userId &&
          moment(sessionKey.expiryDate)
            .subtract("2", "minutes")
            .isBefore(moment())
        ) {
          config.data["sessionKey"] = await dispatch(
            createHelenaSession(parseInt(userId))
          );
          return Promise.resolve(config);
        }
      }
      return Promise.resolve(config);
    },
    (error: any) => Promise.reject(error)
  );

  const getCorrelationIdFromError = (error: AxiosError): string | undefined => {
    const response = error.response;
    if (response && response.data) {
      return response.data.uniqueId;
    } else {
      return "";
    }
  };

  const getMessageFromError = (error: AxiosError): string => {
    const response = error.response;
    if (response && response.data) {
      return response.data.message;
    } else {
      return error.message;
    }
  };

  apiClientAuthenticated = axios.create({
    baseURL: config.backendUrl,
    auth: {
      username: "careconnect_mobile",
      password:
        "L1lUFTzGJjTPgHVdYmasvMXB5KzDIUJk7GRGfuw9bJdPVeYEvMeRqjdTvpkSAQ9"
    }
  });

  apiClientUnauthenticated = axios.create({
    baseURL: config.backendUrl
  });

  apiCorilusPassport = axios.create({
    baseURL: config.corilusPassportUrl
  });
};
